<template>
  <div class="sys-message">
    <el-tooltip :content="tip">
      <svg-icon icon-class="top_message" :style="{fontSize: '20px',marginRight: number > 0 ? 0:10 }" @click="handleShowMessage" />
      <span style="color: red;padding-top: 10px">{{ numberStr }}</span>
    </el-tooltip>
    <el-drawer
      custom-class="message-drawer"
      :visible.sync="drawerVisible"
      size="650px"
    >
      <!--标题 系统消息-->
      <template v-slot:title>
        <div class="title">
          <div class="title-left">
            <span class="title-tip">{{ $t('Message.Message') }}</span>
            <div style="display: flex; margin-top: 6px;">
              <el-checkbox v-model="onlyUnRead" size="" no="onlyUnread" @change="onlyUnReadChangeHandle" />
              <span style="font-size: 14px; margin-left: 3px">{{ $t('Message.OnlyUnRead') }}</span>
            </div>
          </div>
          <div class="title-right">
            <el-button class="drawer-bell-btn-overlay" no="Look" @click="btnAllMarksReadHandle">{{ $t('Message.AllMarksRead') }}</el-button>
            <el-button class="drawer-bell-btn-overlay" no="Edit" @click="btnMsgClassifySetting">{{ $t('Message.MessageConfig') }}</el-button>
          </div>
        </div>
      </template>
      <!--分类-->
      <div class="classify">
        <el-row :gutter="0">
          <el-col v-for="(item, index) in classifyMsgList" :key="index" :span="6">
            <el-tooltip :content="item.name" placement="bottom" effect="light">
              <el-button
                v-show="item.state"
                class="classify-btn drawer-bell-btn-overlay"
                size="medium"
                plain
                :style="{
                  borderRadius: index % 4 === 0 ? '5px 0px 0px 5px' : index % 4 === 3 ? '0px 5px 5px 0px' : index === classifyMsgList.length -1 ? '0px 5px 5px 0px' : '0px'
                }"
                :class="{ 'classify-select': index === classifySelect}"
                @click="btnClassifyChange(item, index)"
              >
                <div class="classify-btn-container">
                  <div style="width: 100px;display: flex;flex-direction: column;justify-content: center">
                    <span class="classify-btn-container-tip">{{ item.name }}</span>
                  </div>
                  <div
                    class="classify-btn-container-number"
                    style="display: inline-block;"
                    :style="{ backgroundColor: item.number ? '#E47470' : '#65B687' }"
                  >{{ item.number ? item.number > 99 ? "99+" : item.number : 0 }}</div>
                </div>
              </el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <!--搜索-->
      <div class="keyword-search" style="display: flex; padding: 15px 0;">
        <el-input v-model="searchKeyword" no="keyword" :placeholder="$t('Message.EnterKeyword')" style="width: 60%; margin-right: 10px" />
        <div style="display:flex; width: 230px; margin-right: 10px">
          <el-date-picker
            v-model="searchDate"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('Pricing.StartTime')"
            :end-placeholder="$t('Pricing.EndTime')"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          />
        </div>
        <div style="margin-right: 0px">
          <el-button style="align-items: end" no="Look" type="primary" @click="queryCurrentMsgNotify">{{ $t('SystemMaintenance.Query') }}</el-button>
        </div>
      </div>
      <!-- 消息内容-->
      <div class="body">
        <div class="table-content">
          <el-table
            :data="filterMsgTable()"
            :show-header="false"
            height="100%"
            stripe
          >
            <el-table-column
              label=""
            >
              <template slot-scope="scope">
                <el-tooltip effect="dark" placement="bottom" disabled>
                  <div slot="content" v-html="scope.row.content" />
                  <div :style="{color:scope.row.color}" @click="readMsgByMouseOrClick(scope.row)" @mouseenter="msgMouseEnterHandle(scope.row)" @mouseleave="msgMouseLeaveHandle(scope.row)">
                    <div>
                      <!--原本的图标是在MsgNotifyConstant中根据code维护的icon，本次全部改为统一的icon-->
                      <img src="@/assets/icons/notify-action-company-x16.png" style="width: 15px;">
                      <!--未读消息标题加粗-->
                      <span
                        :style="{ fontWeight: !scope.row.readed ? 'bold' : '400' }"
                      >
                        {{ scope.row.topic }}
                      </span>
                      <el-button v-if="scope.row && scope.row.link" type="success" style="float:right" @click="btnShowDetailHandler(scope.row)">{{ $t('CargoMsg.Cargo_LookDetail') }}</el-button>
                    </div>
                    <p v-html="scope.row.content" />
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div class="message-contents-footer" style="">
            <cargo-pagination
              :total="msgList.total"
              :page.sync="msgList.pageNum"
              :limit.sync="msgList.pageSize"
              @pagination="queryCurrentMsgNotify"
            />
          </div>
        </div>
      </div>
    </el-drawer>
    <!--消息订阅设置-->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="conf-dialog"
      :visible.sync="showEditDialog"
      :title="$t('SystemMaintenance.BellSubscriptionTitle')"
      width="750px"
      @closed="cancelHandler"
    >
      <div>
        <div class="conf-dialog-title">{{ $t('SystemMaintenance.BellSubscriptionConf') }}</div>
        <div class="conf-dialog-container">
          <el-row :gutter="5">
            <el-col v-for="(item, index) in confFrom" :key="index" :span="6">
              <el-tooltip :content="item.name" placement="bottom" effect="light">
                <div class="conf-dialog-container-col">
                  <span class="conf-dialog-container-col-tip">{{ item.name }}</span>
                  <div>
                    <el-switch
                      v-model="item.state"
                      class="conf-dialog-container-col-switch"
                      active-color="#13ce66"
                      inactive-color="#EAECF0"
                    />
                    <span>{{ item.state ? $t('SystemMaintenance.BellSubscribed') : $t('SystemMaintenance.BellUnSubscribed') }}</span>
                  </div>
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <div class="conf-dialog-title">{{ $t('SystemMaintenance.MessageConfig') }}</div>
        <div class="conf-dialog-container">
          <el-row>
            <el-col :span="1">
              <div class="conf-dialog-container-col" style="width: 200px">
                <img class="conf-dialog-container-icon" src="@/assets/icons/wobao.png">
                <span class="conf-dialog-container-col-tip">{{ $t('SystemMaintenance.WoBaoIntelligentAssistant') }}</span>
                <div>
                  <el-switch
                    v-model="woBaoConfFlag"
                    class="conf-dialog-container-col-switch"
                    active-color="#13ce66"
                    inactive-color="rgb(234,236,240)"
                  />
                  <span>{{ woBaoConfFlag ? $t('SystemMaintenance.WoBaoSubscribed') : $t('SystemMaintenance.WoBaoUnSubscribed') }}</span>
                </div>
              </div>
              <div style="display:flex; width: 190px;margin-left: 10px; margin-top: -2px; line-height: 1.5">
                <i class="el-icon-warning" style="color: #DCA550; margin: 5px 5px 0 0; " />
                <div>{{ $t('SystemMaintenance.WoBaoSubscriptionTip') }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submitHandler">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cache, cacheName } from '@/utils/cacheManager'
import {
  getMessage,
  getUnReadNumber,
  getClassifySubscription,
  saveClassifySubscription,
  readMsg
} from '@/api/messageNotify'
import { mapGetters } from 'vuex'
import { getLoading } from '@/utils/utilBaseElement'
import moment from 'moment'
import { getCargoJumpUrl } from '@/utils/permission'
import { matchView, refreshView } from '@/store/modules/tagsView'
import { MsgNotifyConstants as MsgNotify } from '@/components/Cargo/Common/SysMessage/components/MsgNotifyConstants'
import URL from '@/api/urlTranslator'

export default {
  name: 'SysMessage',
  data() {
    return {
      drawerVisible: false,
      autoTimer: null,
      number: 0,
      numberStr: '',
      tip: '',
      time: 600000, // 自动刷新
      onlyUnRead: true,
      classifyMsgList: [],
      classifySelect: 0,
      woBaoInfo: {
        name: '',
        code: 'WO_BAO',
        state: 'true'
      }, // 沃宝的信息，与classifyMsgList内的属性一致
      confFrom: [],
      confFromUuid: '',
      searchKeyword: '', // 查询关键字
      searchDate: this.getDateRange(), // 查询时间
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate) {
            this.choiceDate = ''
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate).getTime()
          const minTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() - 6)
          const maxTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() + 6)
          const min = minTime
          const data = new Date()
          data.setMonth(data.getMonth() + 3)
          const newDate = new Date(data.toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          const max = newDate < maxTime ? newDate : maxTime
          const now = new Date()
          now.setMonth(now.getMonth() + 3)
          now.setHours(23, 59, 59, 999)
          const curDate = new Date().getTime()
          const three = 180 * 24 * 3600 * 1000
          const threeMonths = curDate - three
          if (this.choiceDate) {
            return time.getTime() < min || time.getTime() > max || time.getTime() > now || time.getTime() < threeMonths
          }
          return time.getTime() > now || time.getTime() < threeMonths
        }
      },
      showEditDialog: false,
      woBaoConfFlag: false,
      currentClassifyCode: 'ALL', // 当前选择的分类uuid
      msgList: {
        list: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        unReadNumber: 0
      },
      storageURL: '',
      timeoutId: null, // 已读消息定时器
      MsgNotifyConstants: new MsgNotify()
    }
  },
  // 进来查询数据和
  async beforeMount() {
    // 加载配置
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
  },
  // 进来时需要处理的信息
  async created() {
    // 同步订阅情况
    await this.getClassifyMsgBySubscribe(false, false)
    // 更新小铃铛的数量
    this.syncUnreadNumber()
    // 定时获取消息
    this.autoGetMessage()
  },
  beforeDestroy() {
    if (this.autoTimer) {
      this.autoTimer = null
      clearInterval(this.autoTimer)
    }
  },
  computed: {
    ...mapGetters([
      'currentOfficeId',
      'tenantId',
      'userInfo'
    ]),
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    // 判断是否打开抽屉，如果打开的话，自动获取全部数据
    'drawerVisible': function(newVal) {
      if (newVal) {
        // 清空缓存的信息
        this.clearSearchCriteria()
        // 查询消息分类信息
        this.getClassifyMsgBySubscribe(true, true)
        // 初始化searchDate为近一个月
        this.searchDate = this.getDateRange()
        // 同步小铃铛的未读消息数量
        this.syncUnreadNumber()
      }
    }
  },
  methods: {
    handleShowMessage() {
      this.drawerVisible = true
    },
    setTip() {
      if (this.number && this.number > 0) {
        this.tip = this.$t('CargoMsg.Cargo_MessageTip1') + this.number + this.$t('CargoMsg.Cargo_MessageTip2')
      } else {
        this.tip = this.$t('Menu.Notice')
      }
    },
    // 自动获取消息数量
    autoGetMessage() {
      if (this.autoTimer) {
        this.autoTimer = null
        clearInterval(this.autoTimer)
      } else {
        this.autoTimer = window.setInterval(() => {
          setTimeout(() => {
            if (this.drawerVisible) {
              return
            }
            if (!this.autoTimer) {
              return
            }
            console.log('定时任务 ==》 autoGetMessage')
            // 同步订阅情况
            this.getClassifyMsgBySubscribe(false, false)
            // 同步小铃铛的消息数量
            this.syncUnreadNumber()
          }, 0)
        }, this.time)
      }
    },
    numberStrHandler(number) {
      const num = number || this.number
      if (num === 0) {
        this.numberStr = ''
      } else if (num > 99) {
        this.numberStr = '99+'
      } else {
        this.numberStr = String(num)
      }
    },
    // 标记是否只看全部
    onlyUnReadChangeHandle() {
      this.queryCurrentMsgNotify()
    },
    // 全部标记为已读
    btnAllMarksReadHandle() {
      // 判断当前分类的未读数量是否大于0 大于0才可以走下面的逻辑
      const currentClassifyInfo = this.classifyMsgList.find(v => v.code === this.currentClassifyCode)
      if (!currentClassifyInfo || currentClassifyInfo.number <= 0) {
        return
      }
      const loading = getLoading()
      // 设置参数为当前的分类
      let param = { 'classifyCode': [this.currentClassifyCode] }
      // 如果为"全部消息"就取全部分类code
      if (this.currentClassifyCode === 'ALL') {
        param = {
          'classifyCode': this.currentClassifyCode = this.classifyMsgList.map(v => {
            if (v.code && v.state) {
              return v.code
            }
          })
        }
      }
      readMsg(param).then(resp => {
        const res = resp.data
        if (res) {
          if (res > 0) {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
            // 重新查询消息
            this.queryCurrentMsgNotify()
            // 同步消息数量
            this.syncUnreadNumber()
          } else {
            this.$message.warning(this.$t('SeaExport.OperationFailed'))
          }
        }
      }).finally(() => loading.close())
    },
    // 打开"个人消息设置"
    btnMsgClassifySetting() {
      this.showEditDialog = true
      this.woBaoConfFlag = this.woBaoInfo.state
    },
    // '消息设置'关闭
    cancelHandler() {
      this.showEditDialog = false
    },
    // 点击分类按钮
    btnClassifyChange(item, index) {
      // 清除所有查询参数
      this.clearSearchCriteria()
      // 将当前按钮所在的分类绑定到当前的currentClassifyUuid参数上
      this.currentClassifyCode = item.code
      // index赋值
      this.classifySelect = index
      // 查询对应分类的信息数据
      this.queryCurrentMsgNotify()
    },
    // 消息配置保存按钮
    async submitHandler() {
      // 处理参数 去掉number
      const data = {
        'uuid': this.confFromUuid,
        'subscriptionInfo': this.confFrom.map(item => {
          return {
            code: item.code,
            state: item.state
          }
        })
      }
      // 添加沃宝的订阅状态
      data.subscriptionInfo.push({
        code: 'WO_BAO',
        state: this.woBaoConfFlag
      })
      const loading = getLoading()
      // 调用接口
      const resp = await saveClassifySubscription(data).finally(() => loading.close())
      if (resp.ok && resp.data >= 0) {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        // 弹窗关闭
        this.showEditDialog = false
        // 重新加载分类数据
        await this.getClassifyMsgBySubscribe(true, true)
        // 同步小铃铛的消息数量
        this.syncUnreadNumber()
        // 将沃宝的订阅状态同步到AppMain.vue文件中
        this.$store.commit('WOBAO_SHOW', this.woBaoConfFlag)
      } else {
        this.$message.warning(this.$t('SeaExport.OperationFailed'))
      }
    },
    // 清空查询条件
    clearSearchCriteria() {
      this.msgList = {
        list: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        unReadNumber: 0
      }
      this.searchKeyword = ''
      this.searchDate = []
    },
    // 查询个人的分类消息订阅情况
    async getClassifyMsgBySubscribe(flag, pullMsgFlag) {
      const loading = getLoading()
      const res = await getClassifySubscription().finally(() => loading.close())
      if (res.data) {
        if (res.data.list) {
          this.classifyMsgList = res.data.list.filter(v => v.code !== 'WO_BAO')
          // 过滤出沃宝的信息
          this.woBaoInfo = res.data.list.find(v => v.code === 'WO_BAO')
          // 将数据赋值给设置的from
          this.confFrom = JSON.parse(JSON.stringify(this.classifyMsgList))
          // 沃宝的订阅状态赋值
          this.woBaoConfFlag = this.woBaoInfo.state
          // 设置值
          this.$store.commit('WOBAO_SHOW', this.woBaoInfo.state)
          // 添加'全部消息'
          this.classifyMsgList.unshift({
            'code': 'ALL',
            'name': this.$t('SystemMaintenance.AllMessage'),
            'state': true
          })
          // 初始化查询是等分类结束后查询数量和当前的数据
          if (flag) {
            // 根据分类获取对应的分类数量
            this.getUnReadNumberByClassify()
            // 判断是否需要拉取数据,目前在定时任务时不需要拉取数据
            if (pullMsgFlag) {
              // 查询消息数据
              this.queryCurrentMsgNotify()
            }
          }
        }
        this.confFromUuid = res.data.uuid
      }
    },
    // 根据分类code查询该用户的未读数量
    getUnReadNumberByClassify() {
      // 构建参数
      const codes = this.classifyMsgList.filter(v => v.state && v.code).map(v => v.code).join(',')
      const dateRange = this.searchDate && this.searchDate.length === 2 ? this.convertSearchDate() : this.getDateRange()
      const loading = getLoading()
      getUnReadNumber(codes, dateRange).then(resp => {
        if (resp.data) {
          this.classifyMsgList.forEach((classify, index) => {
            // 设置 number 如果没有值就直接赋值为0
            const respItem = resp.data.find(v => classify.code === v.code)
            this.$set(this.classifyMsgList[index], 'number', respItem?.number || 0)
          })
        }
      }).finally(() => loading.close())
    },
    // 过滤数据，将没有标题的数据给过滤掉，但是会存在分页数据与实际数据展示不匹配的情况，这个地方是原本的逻辑，本次保持不动！
    filterMsgTable() {
      return this.msgList.list.filter(item => {
        return !!item.topic
      })
    },
    // 接口查询数据
    queryCurrentMsgNotify() {
      // 构建查询参数
      const data = {
        'classifyCode': this.currentClassifyCode === 'ALL' ? this.classifyMsgList.filter(v => v.state && v.code).map(v => v.code) : [this.currentClassifyCode],
        'onlyUnRead': this.onlyUnRead || '',
        'searchKeyword': this.searchKeyword,
        'searchDate': this.convertSearchDate(),
        'dateRange': this.getDateRange(),
        'pageNum': this.msgList.pageNum,
        'pageSize': this.msgList.pageSize
      }
      // 请求接口
      const loading = getLoading()
      getMessage(data).then(res => {
        if (res.data) {
          this.msgList.total = Number(res.data.total)
          this.msgList.pageNum = res.data.pageNum
          this.msgList.pageSize = res.data.pageSize
          this.msgList.list = res.data.list
          this.filter(this.msgList.list)
          this.getUnReadNumberByClassify()
        }
      }).finally(() => loading.close())
    },
    // 消息体鼠标移入后动作
    msgMouseEnterHandle(item) {
      if (item && !item.readed) {
        // 设置一个新的定时器
        this.timeoutId = setTimeout(() => {
          // 超过1秒后调用接口
          this.readMsgByMouseOrClick(item)
        }, 1000)
      }
    },
    // 消息体鼠标移出后动作
    msgMouseLeaveHandle() {
      clearTimeout(this.timeoutId)
    },
    // 鼠标悬浮超过1秒 或者 点击时 将消息设置为已读
    readMsgByMouseOrClick(item) {
      // 有值 且 未读
      if (item && !item.readed) {
        // 调用接口更新已读状态
        readMsg({ 'uuid': item.uuid }).then(resp => {
          const res = resp.data
          if (res) {
            if (res > 0) {
              // 设置为已读
              item.readed = true
              // 将当前分类和全部分类上的未读消息数量-1 因为这个地方可能会存在频繁调用，所以就仅仅在显示上-1 切换分类会重新调用数量和消息数据
              // 因为不知道消息对应的分类code 所以只要已读就调用一次刷新全部分类的未读数量 可以优化为查询消息体是返回code
              this.classifyMsgList.map(v => {
                if (v.code === item.classifyCode || v.code === 'ALL') {
                  if (v && v.hasOwnProperty('number') && v.number >= 1) {
                    v.number--
                  }
                }
              })
              // 同步小铃铛
              this.syncUnreadNumber()
            }
          }
        })
      }
    },
    // 获取今天和三十天前今天的时间, 时间格式为[yyyy-MM-dd,yyyy-MM-dd]
    getDateRange() {
      // 使用 moment.js 获取当前日期
      const today = moment().format('YYYY-MM-DD').toString()
      // 使用 moment.js 获取30天前的日期
      const thirtyDaysAgo = moment().subtract(30, 'days').format('YYYY-MM-DD').toString()
      // 将两个日期放入数组中
      return [thirtyDaysAgo + ' 00:00:00', today + ' 23:59:59']
    },
    btnShowDetailHandler(data) {
      // 获取跳转页签的父类菜单，看是否有权限
      const routeModel = this.getParentModel(data.actionCode)
      const parentRoute = this.routes.find(item => item.module === routeModel)
      if (!routeModel) {
        this.$message.warning(this.$t('Sop.hasPermission'))
        return
      }
      if (!parentRoute) {
        return
      }
      const actionCode = data.link
      if (!actionCode) {
        return
      }
      // 获取子菜单
      const menu = parentRoute.children.find(item => item.module === actionCode)
      if (!menu) {
        return
      }
      if (this.isJumpCargo(menu)) {
        const jumpCargoUrl = getCargoJumpUrl({
          code: actionCode,
          language: this.language,
          sessionId: this.userInfo.sessionId,
          branchId: this.currentOfficeId,
          departmentId: this.currentDeptId
        })
        window.open(jumpCargoUrl, '_blank')
      } else {
        if (data.actionCode === 'CHARGE_CHANGE_NOTICE_SE') {
          this.toLink(menu.name, { jobUuid: data.target, activeTabName: 'tabCharges' })
        } else if (data.actionCode === 'CHARGE_CHANGE_NOTICE_AE') {
          this.toLink(menu.name, { jobUuid: data.target, activeTabName: 'tabCharges' })
        } else {
          this.toLink(menu.name)
        }
      }
    },
    // 是否跳转cargo
    isJumpCargo(item) {
      const user = this.$store.state.user
      // 根据当前分公司判断菜单是否开启跳转H5功能
      if (user && user.menuInfo && user.menuInfo.tenantOfficeMenus) {
        const tenantOfficeMenus = user.menuInfo.tenantOfficeMenus
        const officeUuid = this.$store.getters.currentOfficeUuid
        if (tenantOfficeMenus) {
          for (const tenantOfficeMenu of tenantOfficeMenus) {
            if (item.uuid && item.uuid === tenantOfficeMenu.menuUuid && officeUuid && officeUuid === tenantOfficeMenu.officeUuid) {
              return !tenantOfficeMenu.openH5Url
            }
          }
        }
      }
      return item.jumpCargo
    },
    toLink(name, params = {}) {
      const oldRoute = this.$route
      this.$router.push({ name, params })
      // 路由无变化，手动刷新
      if (this.$route === oldRoute) {
        const view = this.$store.state.tagsView.visitedViews.find(v => matchView(v, this.$route))
        Object.assign(view.params, params)
        refreshView(view)
      }
    },
    getParentModel(actionCode) {
      if (actionCode === 'Combine_charge_item') { // 收费项目
        return 'basicInfo'
      } else if (actionCode === 'IMPORT_ORDER_SE' || actionCode === 'CHARGE_CHANGE_NOTICE_SE') {
        return 'SEAEXPORT'
      } else if (actionCode === 'IMPORT_ORDER_SI') {
        return 'SEAIMPORT'
      } else if (actionCode === 'IMPORT_ORDER_AE' || actionCode === 'CHARGE_CHANGE_NOTICE_AE') {
        return 'AIREXPORT'
      } else if (actionCode === 'IMPORT_ORDER_AI') {
        return 'AIRIMPORT'
      } else if (actionCode === 'IMPORT_ORDER_RE') {
        return 'RAILWAYEXPORT'
      } else if (actionCode === 'IMPORT_ORDER_RI') {
        return 'RAILWAYEXPORT'
      } else if (actionCode === 'IMPORT_ORDER_FBA_SE' || actionCode === 'IMPORT_ORDER_FBA_AE' || actionCode === 'IMPORT_ORDER_FBA_RE' || actionCode === 'IMPORT_ORDER_FBA') {
        return 'FBA'
      } else if (actionCode === 'IMPORT_ORDER_FAILD') {
        return 'Files'
      } else { // 运价
        return 'Freight Rate'
      }
    },
    filter(list) {
      return list.map(item => {
        if (item.actionCode === this.MsgNotifyConstants.FILE_EXPORT_FINISHED.actionCode || item.actionCode === this.MsgNotifyConstants.PRICE_AUDIT_EVENT_FCL.actionCode) {
          item.content = (moment(item.notifyDate).format(this.$t('Message.MMDDDayHHMm'))) + '<br>' + item.content
          item.content = item.content.replace('javascript:void(0)', `${URL.common.findByFileId}/${item.target}?sessionId=${this.userInfo.sessionId}`)
        } else {
          item.content = (moment(item.notifyDate).format(this.$t('Message.MMDDDayHHMm'))) + '    ' + item.content.replace(/size=\'12\'/g, '')
        }
        return item
      })
    },
    // searchDate添加后缀时间
    convertSearchDate() {
      const array = this.searchDate
      if (this.searchDate && this.searchDate.length > 0) {
        if (!this.searchDate[0].includes('00:00:00')) {
          array[0] = this.searchDate[0] + ' 00:00:00'
        }
        if (!this.searchDate[1].includes('23:59:59')) {
          array[1] = this.searchDate[1] + ' 23:59:59'
        }
      }
      return array
    },
    // 同步小铃铛的未读消息数量
    syncUnreadNumber() {
      // 构建参数
      const codeArr = this.classifyMsgList.filter(v => v.state && v.code).map(v => v.code)
      if (!codeArr) {
        return
      }
      const codes = codeArr.join(',')
      const dateRange = this.getDateRange()
      const loading = getLoading()
      getUnReadNumber(codes, dateRange).then(resp => {
        if (resp.ok) {
          if (resp.data) {
            const allItem = resp.data.find(item => item.code === 'ALL')
            if (allItem) {
              this.number = allItem.number || 0
            } else {
              this.number = 0
            }
            this.setTip()
            this.numberStrHandler()
          }
        }
      }).finally(() => loading.close())
    }
  }
}
</script>
<style lang="scss">
.sys-message{
  display: inline-block;
  cursor: pointer;
  .message-drawer{
    .el-drawer__header {
      background-color: rgb(242,242,242);
      margin-bottom: 15px;
      padding: 0 !important;
    }
    .el-drawer__body {
      display: flex;
      flex:1;
      flex-direction: column;
      padding: 15px;
      overflow: hidden;
      padding-top: 0 !important;
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;

      .title-left {
        display: flex;
        align-items: center;
      }

      .title-tip {
        font-weight: bold;
        font-size: 25px;
        color: rgb(51,51,51);
        margin-right: 10px;
      }

      .title-right {
        .el-button {
          border-radius: 6px;

          span {
            font-size: 13px;
          }
        }
      }
    }

    .classify {
      .classify-btn {
        width: 100%;
        margin-top: 15px;
        padding: 10px 5px;

        .classify-btn-container {
          display: flex;
          justify-content: space-between;
          height: 25px;

          .classify-btn-container-tip {
            font-size: 13px;
            width: 95px;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            -webkit-line-clamp: 2; /*2表示只显示2行*/
            /* autoprefixer: off */
            -webkit-box-orient: vertical;
            /* autoprefixer: on */
            //line-height: 2;
            display: -webkit-box;
            text-align: left;
          }

          .classify-btn-container-number {
            color: white;
            width: 35px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 14px;
            display: inline-block;
            border-radius: 5px;
            padding-bottom: 7px;
          }
        }
      }
      .classify-btn:hover {
        color: #FFFFFF;
        background-color: #2E6CB8;
      }
      .classify-select {
        color: #FFFFFF;
        background-color: #2E6CB8;
      }

    }

    .body {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
      .table-content{
        display: flex;
        flex: 1;
        flex-direction: column;
        overflow: hidden;
      }
      &-header {
        text-align: center
      }
      &-body {
        flex: 1;overflow: hidden
      }
      &-footer {

      }
    }

    .drawer-bell-btn-overlay {

    }
  }
  .conf-dialog{
    .el-dialog__title {
      color: rgb(135,135,135);
    }
    .conf-dialog-title {
      font-size: 13px;
      background-color: rgb(245,246,260);
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
      color: rgb(86,86,86);
      font-weight: 600;
    }

    .conf-dialog-container{
      .conf-dialog-container-col {
        display: flex;
        justify-content: space-between;
        align-content: center;
        width: 175px;
        height: 40px;
        border: 1px solid rgb(234,236,240);
        border-radius: 5px;
        align-items: center;
        padding: 0px 5px;
        margin: 10px 5px 10px 5px;
        color: rgb(54,54,54);

        .conf-dialog-container-icon {
          width: 25px;
          height: 25px;
          margin-left: 5px;
        }

        .conf-dialog-container-col-tip {
          font-size: 10px;
          width: 40%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; /*2表示只显示2行*/
          /* autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          line-height: 1.5;
        }
        .conf-dialog-container-col-switch{
          margin-right: 10px;
          zoom: 0.677;
        }
      }
    }
  }

}
</style>
